import { Trigger } from '@zillow/constellation';
import { Paragraph } from '@zillow/constellation';
import { Heading } from '@zillow/constellation';
import { Box } from '@zillow/constellation';
import { Flex } from '@zillow/constellation';
import { Button } from '@zillow/constellation';
import { ModalDialog } from '@zillow/constellation';
import { Formik } from 'formik';
import React, { useCallback } from 'react';
import { IVoidData } from './IVoidData';
import { LoadingButton } from '@zillow/constellation';

interface IVoidConfirmationModalProps {
  onVoid: (x: IVoidData) => Promise<void>;
  'button-data-test-id': string;
  whatAreWeVoiding: string;
  form: React.ReactElement;
  details: React.ReactElement;
  // Any is used here because validation objects can be very complex with no good type
  validationSchema: any;
  initialValues: IVoidData;
}

export const VoidConfirmationModal: React.FC<IVoidConfirmationModalProps> = ({
  onVoid,
  'button-data-test-id': buttonDataTestId,
  whatAreWeVoiding,
  form,
  details,
  validationSchema,
  initialValues,
}) => {
  const onSubmit = useCallback(
    (onClose?: () => void) => {
      return async (values: IVoidData) => {
        await onVoid(values);
        onClose?.();
      };
    },
    [onVoid]
  );
  return (
    <Trigger
      triggered={
        <ModalDialog
          size={'md'}
          scrollDocument
          renderHeader={<Paragraph>Void {whatAreWeVoiding}?</Paragraph>}
          renderBody={(_, { onClose }) => (
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit(onClose)}
              validateOnMount
            >
              {({ isValid, submitForm, isSubmitting }) => (
                <Flex display={'flex'} flexDirection={'column'} gap={1} padding={'sm'}>
                  {form}
                  <Heading level={5}>{whatAreWeVoiding} Details:</Heading>
                  {details}
                  <Flex display={'flex'} flexDirection={'row'} gap={1}>
                    <Box sx={{ flexGrow: '1' }} />
                    <Button buttonType={'secondary'} type="button" onClick={onClose} disabled={isSubmitting}>
                      Cancel
                    </Button>
                    <LoadingButton
                      buttonType="caution"
                      type="button"
                      onClick={submitForm}
                      disabled={!isValid || isSubmitting}
                      loading={isSubmitting}
                    >
                      Void
                    </LoadingButton>
                  </Flex>
                </Flex>
              )}
            </Formik>
          )}
        />
      }
    >
      <Button buttonType={'caution'} type="button" data-test-id={buttonDataTestId}>
        Void
      </Button>
    </Trigger>
  );
};
